<template>
    <v-container fluid>
        <v-card>
            <v-toolbar color="secondary" dense>
                <v-spacer></v-spacer>
                <v-toolbar-title class="white--text"
                    >QB Summaries</v-toolbar-title
                >
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-container>
                <v-form ref="form" lazy-validation>
                    <v-row>
                        <v-spacer></v-spacer>
                        <v-col cols="4">
                            <v-text-field
                                label="Start Date"
                                :value="start"
                                id="start"
                                :placeholder="$store.state.placeholder"
                                v-mask="$store.state.mask"
                                :rules="$store.state.dateRules"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="4">
                            <v-text-field
                                label="End Date"
                                id="end"
                                :value="end"
                                :placeholder="$store.state.placeholder"
                                v-mask="$store.state.mask"
                                :rules="$store.state.dateRules"
                            ></v-text-field>
                        </v-col>
                        <v-spacer></v-spacer>
                    </v-row>
                    <v-row>
                        <v-spacer></v-spacer>
                        <v-col class="ma-3">
                            <v-btn
                                color="success"
                                @click="validate('invSummary')"
                                ><v-icon>mdi-microsoft-excel</v-icon> Invoice
                                Summary</v-btn
                            >
                        </v-col>
                        <v-col class="ma-3">
                            <v-btn
                                color="success"
                                @click="validate('invByTerminal')"
                                ><v-icon>mdi-microsoft-excel</v-icon> Invoice By
                                Terminal</v-btn
                            >
                        </v-col>
                        <v-spacer></v-spacer>
                    </v-row>
                    <v-row>
                        <v-spacer></v-spacer>
                        <v-col class="ma-3">
                            <v-btn
                                color="success"
                                @click="validate('paySummary')"
                                ><v-icon>mdi-microsoft-excel</v-icon> Payroll
                                Summary</v-btn
                            >
                        </v-col>
                        <v-col class="ma-3">
                            <v-btn
                                color="success"
                                @click="validate('payByTerminal')"
                                ><v-icon>mdi-microsoft-excel</v-icon> Payroll By
                                Terminal</v-btn
                            >
                        </v-col>
                        <v-spacer></v-spacer>
                    </v-row>
                    <v-row>
                        <v-spacer></v-spacer>
                        <v-col class="ma-3">
                            <v-btn color="success" @click="validate('payADP')"
                                ><v-icon>mdi-microsoft-excel</v-icon>
                                Payroll ADP
                            </v-btn>
                        </v-col>
                        <v-col class="ma-3">
                            <v-btn
                                color="success"
                                @click="validate('creditReport')"
                                ><v-icon>mdi-microsoft-excel</v-icon> Invoice
                                Credit
                            </v-btn>
                        </v-col>
                        <v-spacer></v-spacer>
                    </v-row>
                    <v-row justify="center">
                        <v-col cols="3">
                            <v-btn
                                color="secondary"
                                @click="validate('By Truck')"
                                ><v-icon class="pr-2">mdi-tanker-truck</v-icon>
                                By Truck
                            </v-btn>
                        </v-col>
                        <v-col cols="3">
                            <v-btn
                                color="secondary"
                                @click="validate('By Station')"
                                ><v-icon class="pr-2">mdi-gas-station</v-icon>
                                By Station
                            </v-btn>
                        </v-col>
                        <v-col cols="3">
                            <v-btn
                                color="secondary"
                                @click="validate('By Customer')"
                                ><v-icon class="pr-2">mdi-account-group</v-icon>
                                By Customer
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-form>
            </v-container>
        </v-card>
        <v-divider></v-divider>
        <v-card>
            <v-container grid-list-xs>
                <v-row>
                    <v-col cols="2">
                        <v-combobox
                            v-model="report"
                            placeholder="Select Company"
                            class="mx-3"
                            label="Select Report"
                            :items="reports"
                            dense
                            hide-details
                            :item-text="'text'"
                            @change="selectCompany"
                        ></v-combobox>
                    </v-col>
                    <v-col cols="1">
                        <v-combobox
                            v-model="company"
                            placeholder="Select Report"
                            class="mx-3"
                            label="Company"
                            :items="companies"
                            dense
                            hide-details
                            :item-text="'CompanyName'"
                            :item-value="'CompanyID'"
                            @change="selectCompany"
                        ></v-combobox>
                    </v-col>
                    <v-btn
                        color="secondary"
                        class="mt-2"
                        @click="exportNewReports"
                        >Download</v-btn
                    >
                </v-row>
            </v-container>
        </v-card>
    </v-container>
</template>
<script>
import { mask } from 'vue-the-mask';
import axios from 'axios';
export default {
    directives: { mask },
    data: function() {
        return {
            pdfDialog: false,
            urlPdf: '',
            start: '',
            end: '',
            valid: true,
            companies: [],
            company: null,
            dateRules: [
                v => !!v || 'This date is required',
                v =>
                    (parseInt(v[5] + v[6]) <= 12 &&
                        parseInt(v[5] + v[6]) > 0) ||
                    'Date Incorrect',
                v =>
                    (parseInt(v[8] + v[9]) <= 31 &&
                        parseInt(v[8] + v[9]) > 0) ||
                    'Date Incorrect'
            ],
            report: null,
            reports: [
                {
                    text: 'Invoice Summary to QB',
                    id: 1,
                    url: 'invoice/report/company',
                    type: 'xlsx'
                },
                {
                    text: 'Payroll OO',
                    id: 2,
                    url: 'invoice/report/oo',
                    type: 'xlsx'
                },
                {
                    text: 'Contractors',
                    id: 3,
                    url: 'invoice/report/contractor',
                    type: 'xlsx'
                }
            ]
        };
    },
    mounted() {
        this.getCompanies();
    },
    methods: {
        getCompanies: function() {
            this.$store.state.isLoading = true;
            axios
                .get('company')
                .then(response => {
                    this.companies = response.data;
                })
                .catch(function(error) {
                    console.log(error);
                });
            this.$store.state.isLoading = false;
        },
        exportExcel: function() {
            var str = this.$store;
            this.$store.state.isLoading = true;
            var parms = {
                StartDate: this.$store.state.getMsk('start'),
                EndDate: this.$store.state.getMsk('end'),
                Export: 1
            };
            console.log(parms);
            axios
                .post('invoice/summaryReport', parms, {
                    responseType: 'blob',
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    const url = window.URL.createObjectURL(
                        new Blob([response.data])
                    );
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute(
                        'download',
                        'Invoice Summary Report.xlsx'
                    );
                    document.body.appendChild(link);
                    link.click();
                    this.$store.state.isLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                    str.state.isLoading = false;
                });
        },
        exportExcelByTerminal: function() {
            var str = this.$store;
            this.$store.state.isLoading = true;
            var parms = {
                StartDate: this.$store.state.getMsk('start'),
                EndDate: this.$store.state.getMsk('end'),
                Export: 1
            };
            console.log(parms);
            axios
                .post('invoice/byTerminalReport', parms, {
                    responseType: 'blob',
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    const url = window.URL.createObjectURL(
                        new Blob([response.data])
                    );
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'Invoice By Terminal.xlsx');
                    document.body.appendChild(link);
                    link.click();
                    this.$store.state.isLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                    str.state.isLoading = false;
                });
        },
        exportExcelPaySummary: function() {
            var str = this.$store;
            this.$store.state.isLoading = true;
            var parms = {
                StartDate: this.$store.state.getMsk('start'),
                EndDate: this.$store.state.getMsk('end'),
                Export: 1
            };
            console.log(parms);
            axios
                .post('payroll/summaryReport', parms, {
                    responseType: 'blob',
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    const url = window.URL.createObjectURL(
                        new Blob([response.data])
                    );
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'Payroll Summary.xlsx');
                    document.body.appendChild(link);
                    link.click();
                    this.$store.state.isLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                    str.state.isLoading = false;
                });
        },
        exportExcelPayByTerminal: function() {
            var str = this.$store;
            this.$store.state.isLoading = true;
            var parms = {
                StartDate: this.$store.state.getMsk('start'),
                EndDate: this.$store.state.getMsk('end'),
                Export: 1
            };
            console.log(parms);
            axios
                .post('payroll/byTerminalReport', parms, {
                    responseType: 'blob',
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    const url = window.URL.createObjectURL(
                        new Blob([response.data])
                    );
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'Payroll By Terminal.xlsx');
                    document.body.appendChild(link);
                    link.click();
                    this.$store.state.isLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                    str.state.isLoading = false;
                });
        },
        exportPayrollADP: function() {
            var str = this.$store;
            this.$store.state.isLoading = true;
            var parms = {
                StartDate: this.$store.state.getMsk('start'),
                EndDate: this.$store.state.getMsk('end'),
                Export: 1
            };
            console.log(parms);
            axios
                .post('payroll/ADPReport', parms, {
                    responseType: 'blob',
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    const url = window.URL.createObjectURL(
                        new Blob([response.data])
                    );
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'Payroll ADP Report.xlsx');
                    document.body.appendChild(link);
                    link.click();
                    this.$store.state.isLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                    str.state.isLoading = false;
                });
        },
        exportCreditReport: function() {
            var str = this.$store;
            this.$store.state.isLoading = true;
            var parms = {
                StartDate: this.$store.state.getMsk('start'),
                EndDate: this.$store.state.getMsk('end'),
                Export: 1,
                Credit: 1
            };
            console.log(parms);
            axios
                .post('invoice/summaryReport', parms, {
                    responseType: 'blob',
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    const url = window.URL.createObjectURL(
                        new Blob([response.data])
                    );
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'Invoice Credit Report.xlsx');
                    document.body.appendChild(link);
                    link.click();
                    this.$store.state.isLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                    str.state.isLoading = false;
                });
        },
        exportByTruck: function() {
            var str = this.$store;
            this.$store.state.isLoading = true;
            var parms = {
                StartDate: this.$store.state.getMsk('start'),
                EndDate: this.$store.state.getMsk('end'),
                Export: 1,
                Credit: 1
            };
            console.log(parms);
            axios
                .post('report/export/by-truck', parms, {
                    responseType: 'blob',
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    const url = window.URL.createObjectURL(
                        new Blob([response.data])
                    );
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'Report By Truck.xlsx');
                    document.body.appendChild(link);
                    link.click();
                    this.$store.state.isLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                    str.state.isLoading = false;
                });
        },
        exportByCustomer: function() {
            var str = this.$store;
            this.$store.state.isLoading = true;
            var parms = {
                StartDate: this.$store.state.getMsk('start'),
                EndDate: this.$store.state.getMsk('end'),
                Export: 1,
                Credit: 1
            };
            console.log(parms);
            axios
                .post('report/export/by-customer', parms, {
                    responseType: 'blob',
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    const url = window.URL.createObjectURL(
                        new Blob([response.data])
                    );
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'Report By Customer.xlsx');
                    document.body.appendChild(link);
                    link.click();
                    this.$store.state.isLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                    str.state.isLoading = false;
                });
        },
        exportByStation: function() {
            var str = this.$store;
            this.$store.state.isLoading = true;
            var parms = {
                StartDate: this.$store.state.getMsk('start'),
                EndDate: this.$store.state.getMsk('end'),
                Export: 1,
                Credit: 1
            };
            console.log(parms);
            axios
                .post('report/export/by-station', parms, {
                    responseType: 'blob',
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    const url = window.URL.createObjectURL(
                        new Blob([response.data])
                    );
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'Report By Station.xlsx');
                    document.body.appendChild(link);
                    link.click();
                    this.$store.state.isLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                    str.state.isLoading = false;
                });
        },
        validate(i) {
            if (this.$refs.form.validate() == false) {
                this.$refs.form.validate();
            } else {
                if (i == 'invSummary') {
                    this.exportExcel();
                }
                if (i == 'invByTerminal') {
                    this.exportExcelByTerminal();
                }
                if (i == 'payByTerminal') {
                    this.exportExcelPayByTerminal();
                }
                if (i == 'paySummary') {
                    this.exportExcelPaySummary();
                }
                if (i == 'payADP') {
                    this.exportPayrollADP();
                }
                if (i == 'creditReport') {
                    this.exportCreditReport();
                }
                if (i == 'By Truck') {
                    this.exportByTruck();
                }

                if (i == 'By Customer') {
                    this.exportByCustomer();
                }

                if (i == 'By Station') {
                    this.exportByStation();
                }
            }
        },
        exportNewReports: function() {
            var str = this.$store;
            this.$store.state.isLoading = true;
            var parms = {
                StartDate: this.$store.state.getMsk('start'),
                EndDate: this.$store.state.getMsk('end'),
                Company: this.company == null ? null : this.company.CompanyID,
                Export: 1
            };
            console.log(parms);
            axios
                .post(this.report.url, parms, {
                    responseType: 'blob',
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    const url = window.URL.createObjectURL(
                        new Blob([response.data])
                    );
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute(
                        'download',
                        this.report.text + '.' + this.report.type
                    );
                    document.body.appendChild(link);
                    link.click();
                    this.$store.state.isLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                    str.state.isLoading = false;
                });
        }
    }
};
</script>
